import { createActions } from 'redux-actions';
import types from 'state/direct-order/ui/actionTypes';

const { directOrder } = createActions({
  [types.SET_FETCHING]: (isFetching) => ({ isFetching }),
  [types.SET_SUBMITTING]: (isSubmitting) => ({ isSubmitting }),
});

export default directOrder;
